"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var load = require("load-script");

function createWidget(id, cb) {
  return load('https://w.soundcloud.com/player/api.js', function () {
    return cb(window.SC.Widget(id));
  });
}

exports.createWidget = createWidget;